<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/jifen'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg t="1653550343573"
                     viewBox="0 0 1024 1024"
                     version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                     p-id="1900"
                     width="64"
                     height="64">
                  <path d="M936.19430083 700.53080036a47.1327001 47.1327001 0 0 1 47.1327001 47.13270012c0 140.59684437-213.88819302 235.66350048-471.32700093 235.66350045S40.67299907 888.26034484 40.67299907 747.66350048a47.1327001 47.1327001 0 0 1 93.93547129-5.51452592L134.93839925 747.66350048c0 67.63542463 165.90710432 141.39810029 377.06160075 141.39810027 206.29982832 0 369.52036874-70.41625394 376.82593725-136.77909568L889.06160075 747.66350048a47.1327001 47.1327001 0 0 1 47.13270008-47.13270012z m0-235.66350046a47.1327001 47.1327001 0 0 1 47.1327001 47.1327001c0 140.59684437-213.88819302 235.66350048-471.32700093 235.66350048S40.67299907 652.59684437 40.67299907 512a47.1327001 47.1327001 0 0 1 93.93547129-5.51452591L134.93839925 512c0 67.63542463 165.90710432 141.39810029 377.06160075 141.39810029 206.29982832 0 369.52036874-70.41625394 376.82593725-136.77909568L889.06160075 512a47.1327001 47.1327001 0 0 1 47.13270008-47.1327001z m-424.19430083-424.19430083c257.4388079 0 471.32700093 95.0666561 471.32700093 235.66350045s-213.88819302 235.66350048-471.32700093 235.66350048-471.32700093-95.0666561-471.32700093-235.66350048 213.88819302-235.66350048 471.32700093-235.66350045z m0 94.26540018c-211.15449641 0-377.06160075 73.76267565-377.06160075 141.39810027s165.90710432 141.39810029 377.06160075 141.39810029 377.06160075-73.76267565 377.06160075-141.39810029-165.90710432-141.39810029-377.06160075-141.39810027z"
                        p-id="1901"></path>
                </svg>
                我的积分
              </h2>
              <div style="float: right">
                <el-button type="text"
                           @click="showChongzhi = true">
                  积分充值
                </el-button>
              </div>
            </div>
            <div class="box">
              <div class="box-content"
                   v-loading="loading">
                <el-table :data="tableData"
                          style="width: 100%">
                  <el-table-column align="center"
                                   label="序号"
                                   type="index"
                                   width="80"
                                   :index="handleTableIndex">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="操作类型"
                                   min-width=""
                                   prop="eventTitle">
                  </el-table-column>
                  <!-- <el-table-column align="center" label="积分变动" width="150">
                    <template #default="scope">
                      <el-tag type="">
                        {{ scope.row.type === 0 ? "+" : "-"
                        }}{{ scope.row.integral }}
                      </el-tag>
                    </template>
                  </el-table-column> -->
                  <el-table-column align="center"
                                   label="积分变动"
                                   width="150">
                    <template #default="scope">
                      <el-tag v-if="scope.row.realIntegral === 0">
                        免费
                      </el-tag>
                      <el-tag type=""
                              v-else>
                        {{ scope.row.type === 0 ? "+" : "-"
                        }}{{ scope.row.realIntegral }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="时间"
                                   width="160">
                    <template #default="scope">
                      {{ dateFormat(scope.row.createTime) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="累计积分"
                                   prop="surplus"
                                   width="250">
                  </el-table-column>
                </el-table>
                <div class="list-bottom">
                  <div class="list-page-total">
                    共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                  </div>
                  <div class="list-page">
                    <el-pagination :current-page="pageIndex"
                                   :page-size="pageSize"
                                   layout="prev,pager,next,jumper"
                                   :total="total"
                                   @current-change="handleCurrentPageChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="积分充值"
               :visible.sync="showChongzhi"
               width="855px">
      <div class="pay"
           style="margin-top: 20px">
        <div class="type-select">
          <el-radio-group v-model="payMoney"
                          @change="handleChange"
                          size="small">
            <template v-for="(item, index) in payMoneyList">
              <el-radio :class="item.label === 0 ? 'y' : item.label === 1 ? 's' : 'm'"
                        :label="item.label"
                        border
                        :key="index">
                <span class="price">
                  {{ item.money }}
                  <sub>元</sub>
                </span>
                <span class="name"> {{ item.num }} 积分 </span>
              </el-radio>
            </template>
          </el-radio-group>
        </div>

        <div class="border">
          <div class="amount">
            应付金额：
            <strong>{{ showMoney }}</strong>
            元
          </div>
          <div class="pay-select">
            <el-radio-group v-model="payType">
              <el-radio :label="0">
                <img src="~@/assets/images/pay-wechat.png"
                     alt="" />
              </el-radio>
              <el-radio :label="1">
                <img src="~@/assets/images/pay-ali.png"
                     alt="" />
              </el-radio>
            </el-radio-group>
          </div>
          <div class="submit">
            <el-button @click="handlePayOk()"
                       type="primary"
                       round>
              确认充值
            </el-button>
          </div>
          <div class="tip">
            <a href="javascript:void(0);"
               style="color: red"
               @click="handlerAgreement">
              支付即同意《VIP服务协议》
            </a>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="agreement.title"
               :visible.sync="showAgreement">
      <span v-html="agreement.content"></span>
    </el-dialog>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data () {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      loading: false,
      showChongzhi: false,
      agreement: {},
      showAgreement: false,
      payMoneyList: [
        { label: 0, money: 100, num: 80000 },
        { label: 1, money: 50, num: 20000 },
        { label: 2, money: 10, num: 3000 },
      ],
      payMoney: 0,
      payType: 0,
      showMoney: 100,
    };
  },
  created () {
    this.getAgreement(5);
    this.getList();
  },
  methods: {
    handlePayOk () {
      if (this.payType === 0) {
        this.$router.push({
          path: "/user/wechatpay",
          query: {
            JifenTypeId: this.payMoney,
            PayMoney: this.showMoney,
          },
        });
      } else if (this.payType === 1) {
        axiosRequest(
          "/vip/ali-pay-jifen",
          { type: this.payMoney },
          axiosOptions("post", "", "json")
        ).then((res) => {
          if (res.data.code === 200) {
            const div = document.createElement("div");
            div.innerHTML = res.data.data;
            document.body.appendChild(div);
            document.forms[0].submit();
          } else {
            this.$message.error("提交失败，请稍后重试！");
          }
        });
      }
    },
    handlerAgreement () {
      this.showAgreement = true;
    },
    getAgreement (id) {
      axiosRequest(
        "/agreement/details",
        { id: id },
        axiosOptions("post", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.agreement = res.data.data;
        }
      });
    },
    handleChange () {
      this.showMoney = this.payMoneyList.find(
        (i) => i.label === this.payMoney
      ).money;
    },
    handleTableIndex (index) {
      return ((this.pageIndex || 1) - 1) * (this.pageSize || 10) + index + 1;
    },
    dateFormat (cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    getList () {
      this.loading = true;

      axiosRequest(
        "/user/integral-list",
        { pageIndex: this.pageIndex, pageSize: this.pageSize },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
            this.tableData = res.data.data.records;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentPageChange (currentPage) {
      this.pageIndex = currentPage;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";
.intro {
  height: 90px;
  margin-bottom: 15px;
  padding: 20px;
  font-size: $fontSizeSmall;
  font-weight: bold;
  line-height: 30px;
  color: #fff;
  background-color: $colorMain;
  border-radius: 5px 5px 0 0;
  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 30px;
    vertical-align: -10px;
  }
  strong {
    margin: 0 5px;
    color: #ffc001;
  }
}
.vip-tabs {
  //   margin-top: -65px;
  margin-top: -40px;
  ::v-deep {
    .el-tabs__header {
      border: 0;
    }
    .el-tabs__nav-wrap {
      margin-bottom: 0;
    }
    .el-tabs__nav {
      width: 100%;
      border: 0;
    }
    .el-tabs__item {
      width: 50%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      text-align: center;
      background-color: #ebebeb;
      border: 0;

      &.is-active {
        background-color: #fff;
        z-index: 1;
      }
      &:first-child {
        width: calc(50% - 20px);
        margin-right: 20px;
        border-radius: 10px 25px 0 0;
        &.is-active {
          &:after {
            border-left-color: #fff;
            border-bottom-color: #fff;
          }
        }
        &:after {
          position: absolute;
          bottom: 0;
          border-width: 24px 40px;
          border-style: solid;
          border-color: transparent;
          content: "";
          right: -65px;
          border-left-color: #ebebeb;
          border-bottom-color: #ebebeb;
        }
      }
      &:last-child {
        width: calc(50% - 20px);
        margin-left: 20px;
        border-radius: 25px 10px 0 0;
        &.is-active {
          &:before {
            border-right-color: #fff;
            border-bottom-color: #fff;
          }
        }
        &:before {
          position: absolute;
          bottom: 0;
          border-width: 24px 40px;
          border-style: solid;
          border-color: transparent;
          content: "";
          left: -65px;
          border-right-color: #ebebeb;
          border-bottom-color: #ebebeb;
        }
      }
      .el-badge {
        vertical-align: top;
      }
      .el-badge__content.is-fixed {
        top: 12px;
      }
      svg {
        font-size: 1.2em;
        margin-right: 5px;
        vertical-align: -4px;
      }
    }
  }
}
.adv {
  position: relative;
  margin-bottom: 50px;
  img {
    width: 100%;
  }
  .text {
    position: absolute;
    right: 80px;
    top: 28px;
    font-size: 30px;
    font-weight: bold;
    color: #ff1e00;
  }
}
.type-select {
  margin-bottom: 35px;
  text-align: center;
  .el-radio {
    width: 245px;
    height: 160px;
    padding: 25px;
    border: 1px solid #e5e5e5;
    vertical-align: top;
    @media screen and (max-width: 768px) {
      width: 167%;
      margin: 0 0 15px !important;
      transform: scale(0.6);
      transform-origin: 0 0;
      + .el-radio {
        margin-top: -60px !important;
      }
    }
    &.is-checked {
      border: 2px solid #ff5a00;
      box-shadow: 0 5px 10px rgba(255, 90, 0, 0.2);
      ::v-deep {
        .el-radio__label {
          &:before {
            position: absolute;
            right: 3px;
            bottom: 2px;
            width: 13px;
            height: 13px;
            font-family: element-icons !important;
            font-size: 16px;
            color: #fff;
            z-index: 1;
            content: "";
          }
          &:after {
            position: absolute;
            right: 0;
            bottom: 0;
            border-width: 13px;
            border-style: solid;
            border-color: transparent #ff5a00 #ff5a00 transparent;
            content: "";
          }
        }
      }
    }
    &.y {
      &:before {
        position: absolute;
        left: -2px;
        top: -13px;
        width: 48px;
        height: 27px;
        background: url(~@/assets/images/pay-type-sp1.png) no-repeat;
        content: "";
      }
      &:after {
        position: absolute;
        right: 17px;
        top: 0px;
        width: 34px;
        height: 34px;
        background: url(~@/assets/images/pay-type-sp2.png) no-repeat;
        content: "";
      }
    }
    &.s {
      ::v-deep {
        .el-radio__label {
          > span.name {
            color: #e8a203;
          }
        }
      }
    }
    &.m {
      ::v-deep {
        .el-radio__label {
          > span.name {
            color: #666666;
          }
        }
      }
    }
    ::v-deep {
      .el-radio__input {
        display: none;
      }
      .el-radio__label {
        display: block;

        > span {
          display: block;
          &.price {
            height: 60px;
            margin-bottom: 10px;
            font-size: 36px;
            font-weight: bold;
            color: #ff3f15;
            line-height: 54px;
            border-bottom: 1px dashed #c8c9cc;
            small {
              font-size: 18px;
              font-weight: normal;
              color: #333333;
              vertical-align: 2px;
              del {
                vertical-align: -2px;
              }
            }
            sub {
              font-size: 14px;
              font-weight: normal;
              color: #333333;
              vertical-align: 1px;
              span {
                color: #ff3f15;
              }
            }
          }
          &.name {
            font-size: 16px;
            line-height: 30px;
            color: #f70f36;
            img {
              margin-right: 5px;
              vertical-align: -2px;
            }
          }
        }
      }
    }
  }
}
.border {
  padding: 25px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;

  .submit {
    margin: 40px 0 0;
    border: 0;
    .el-button {
      width: 184px;
      height: 45px;
      font-size: 18px;
      background-color: #68bf7b !important;
      border-color: #68bf7b !important;
      border-radius: 50px;
      @media screen and (max-width: 768px) {
        width: 100%;
        height: 40px;
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  * + .border {
    margin-top: -90px;
  }
}

.amount {
  margin-bottom: 40px;
  font-size: 16px;
  color: #262626;
  strong {
    font-size: 24px;
    color: #ff3900;
  }
}
.pay-select {
  .el-radio {
    img {
      vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-right: 0;
      + .el-radio {
        margin-top: 20px;
      }
    }
  }
  ::v-deep {
    .el-radio__input.is-checked {
      .el-radio__inner:after {
        background-color: #68bf7b;
      }
    }
    .el-radio__inner {
      width: 22px;
      height: 22px;
      background-color: #fff;
      border-color: #68bf7b;
      &:after {
        width: 10px;
        height: 10px;
      }
    }
  }
}
.exchange {
  padding: 50px 80px;
  @media screen and (max-width: 768px) {
    padding: 0;
  }
  .name {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .input {
    text-align: center;
    .el-input {
      width: 365px;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-bottom: 15px;
      }
    }
    .el-button {
      margin-left: 10px;
      width: 100px;
    }
  }
}
.tip {
  margin-top: 60px;
  text-align: left;
}
.pay-ok {
  padding: 20px;
  text-align: center;
  line-height: 50px;
  img {
    margin-bottom: 30px;
    margin-right: -33px;
  }
  h4 {
    font-size: 30px;
    font-weight: bold;
  }
  p {
    font-size: 18px;
    strong {
      color: #ff0000;
    }
  }
}
</style>
